/** @format */

import React from 'react';

// A Section can be either disabled (semi-transparent) or fully hidden (display: none).
export default function Section({enabled = true, visible = true, children}) {
    const disabled = !enabled;
    const hidden = !visible;
    const disabledStyle = {
        opacity: 0.25,
        pointerEvents: 'none'
    };
    return (
        <section hidden={hidden} aria-hidden={disabled} style={disabled ? disabledStyle : null}>
            {children}
        </section>
    );
}
